import { organizationComputed, organizationMethods } from '@state/helpers';
import Color from 'color';

export const themeMixin = {
  data() {
    return {};
  },
  computed: {
    ...organizationComputed,
  },
  methods: {
    ...organizationMethods,
    setOrganizationTheme() {
      const r = document.querySelector(':root');
      console.log(this.organizationColor);
      if (this.organizationColor) {
        r.style.setProperty(
          '--color-primary',
          Color(this.organizationColor)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-alt',
          Color(this.organizationColor)
            .lighten(0.1)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-one',
          Color(this.organizationColor)
            .rotate(13)
            .lighten(0.08)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-two',
          Color(this.organizationColor)
            .rotate(8)
            .lighten(0.23)
            .saturate(0.69)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-three',
          Color(this.organizationColor)
            .rotate(13)
            .darken(0.1)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-four',
          Color(this.organizationColor)
            .rotate(3)
            .saturate(1)
            .darken(0.05)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-five',
          Color(this.organizationColor)
            .rotate(12)
            .desaturate(0.27)
            .darken(0.1)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-six',
          Color(this.organizationColor)
            .rotate(15)
            .saturate(0.05)
            .lighten(0.06)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-seven',
          Color(this.organizationColor)
            .rotate(13)
            .saturate(0.2)
            .lighten(0.08)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-eight',
          Color(this.organizationColor)
            .rotate(13)
            .desaturate(0.01)
            .lighten(0.06)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-nine',
          Color(this.organizationColor)
            .rotate(13)
            .lighten(0.05)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-ten',
          Color(this.organizationColor)
            .rotate(13)
            .lighten(0.42)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-eleven',
          Color(this.organizationColor)
            .rotate(13)
            .darken(0.04)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-twelve',
          Color(this.organizationColor)
            .rotate(12)
            .darken(0.15)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-thirteen',
          Color(this.organizationColor)
            .rotate(13)
            .rgb()
            .array()
            .join(',')
        );
        r.style.setProperty(
          '--color-primary-fourteen',
          Color(this.organizationColor)
            .rotate(13)
            .lighten(0.03)
            .rgb()
            .array()
            .join(',')
        );
      }
    },
  },
  async mounted() {
    if (process.env.VUE_APP_ORG_ID) {
      await this.getOrg(process.env.VUE_APP_ORG_ID);
      this.setOrganizationTheme();
    }
  },
};
